var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.252,
    height: 35.423,
    viewBox: "0 0 30.252 35.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2582",
    "data-name": "Group 2582",
    transform: "translate(-1720.748 -40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-bell-5396998",
    d: "M159.287,45.135a3.6,3.6,0,0,1,.019.37,3.654,3.654,0,0,1-7.309,0,3.528,3.528,0,0,1,.019-.37h-9.377a.741.741,0,0,1-.74-.74V41.758a.736.736,0,0,1,.146-.441l2.212-3.514V28.021l.006-.094a11.408,11.408,0,0,1,9.02-10.677v-.883a2.368,2.368,0,0,1,4.736,0v.883a11.408,11.408,0,0,1,9.023,10.745l0,9.809,2.242,3.562a.737.737,0,0,1,.114.393l0,2.636a.741.741,0,0,1-.74.74h-9.377Z",
    transform: "translate(1578.849 26.264)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(1737 40)",
    fill: "#de0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/notification-active.49f3af8cfa085e149ae9426afa1d7a0e.svg";
export { ForwardRef as ReactComponent };